export default __webpack_public_path__ + "static/nick-bitmoji-e91a0d5fe5aae61ed659be0a3ef6361d.png";